var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4917 1.66663H6.50841C3.47508 1.66663 1.66675 3.47496 1.66675 6.50829V13.4833C1.66675 16.525 3.47508 18.3333 6.50841 18.3333H13.4834C16.5167 18.3333 18.3251 16.525 18.3251 13.4916V6.50829C18.3334 3.47496 16.5251 1.66663 13.4917 1.66663ZM13.9834 8.08329L9.25841 12.8083C9.14175 12.925 8.98341 12.9916 8.81675 12.9916C8.65008 12.9916 8.49175 12.925 8.37508 12.8083L6.01675 10.45C5.77508 10.2083 5.77508 9.80829 6.01675 9.56663C6.25841 9.32496 6.65841 9.32496 6.90008 9.56663L8.81675 11.4833L13.1001 7.19996C13.3417 6.95829 13.7417 6.95829 13.9834 7.19996C14.2251 7.44163 14.2251 7.83329 13.9834 8.08329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxActiveIcon);
export default __webpack_public_path__ + "static/media/check-box-active-icon.fbca96101c6bb3760aa62adb2e5a0d6a.svg";
export { ForwardRef as ReactComponent };